import HundDto from "../../../../consumer/form/dto/HundDto";
import StvJaNeinUnbekannt from "../../../../consumer/form/dto/StvJaNeinUnbekannt";
import { exportName } from "./input/HundeName";
import { exportRasse, exportRasseVersicherbar } from "./input/HundeRasse";

export default class FormHundBo {
    name: string = '';
    rasse?: string = '';
    rasseVersicherbar?: StvJaNeinUnbekannt;

    static exportViewAsDto(bo: FormHundBo) {
        const dto = new HundDto();
        dto.name = exportName(bo);
        dto.rasse = exportRasse(bo);
        dto.rasseVersicherbar = exportRasseVersicherbar(bo);
        return dto;
    }


}